import { cva as t, ct as e } from "@/styled-system/css";
const r = t({
  base: {
    color: "inherit",
    flex: "0 1 auto",
    textStyle: e("Banner.typography.body.textStyles")
  }
});
export {
  r as bannerBodyRecipe
};
//# sourceMappingURL=banner-body.styles.js.map
